/* Multiple images with text - Elixir port. Initialises every .mit instance on the page. */
(function () {
  function init(root) {
    if (root.dataset.mitReady === 'true') return;
    root.dataset.mitReady = 'true';

    var count = parseInt(root.dataset.count, 10) || 0;
    if (count < 1) return;

    var imgs = root.querySelectorAll('.mit__img');
    var panels = root.querySelectorAll('.mit__panel');
    var dots = root.querySelectorAll('.mit__dot');
    var active = 0;
    var timer = null;

    function render() {
      imgs.forEach(function (el, i) {
        var depth = (i - active + count) % count;
        el.style.setProperty('--depth', depth);
        if (depth === 0) el.setAttribute('data-active', 'true');
        else el.removeAttribute('data-active');
      });
      panels.forEach(function (el, i) {
        if (i === active) el.setAttribute('data-active', 'true');
        else el.removeAttribute('data-active');
      });
      dots.forEach(function (el, i) {
        if (i === active) el.setAttribute('data-active', 'true');
        else el.removeAttribute('data-active');
      });
    }

    function go(i) {
      active = (i + count) % count;
      render();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (root.dataset.autoplay !== 'true' || count < 2) return;
      var ms = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
      timer = setInterval(function () { go(active + 1); }, ms);
    }

    root.querySelectorAll('.mit__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(active + parseInt(btn.dataset.dir, 10));
        stop();
      });
    });

    dots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(parseInt(btn.dataset.goto, 10));
        stop();
      });
    });

    imgs.forEach(function (el) {
      el.addEventListener('click', function () {
        go(parseInt(el.dataset.index, 10));
        stop();
      });
    });

    root.addEventListener('mouseenter', stop);

    root.mitGoTo = function (i) { stop(); go(i); };

    render();
    start();
  }

  function initAll() {
    document.querySelectorAll('.mit').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('.mit');
    if (!root || typeof root.mitGoTo !== 'function') return;
    var idx = e.target.getAttribute('data-index');
    if (idx !== null) root.mitGoTo(parseInt(idx, 10));
  });
})();
